// Foundation strings for the authenticated app shell: shared UI-primitive
// chrome (close buttons, sidebar a11y text), the sidebar nav + profile menu,
// and small cross-cutting labels (Today/Yesterday, the language switcher
// itself). Merged into `translations` by ../i18n.js.
export const shell = {
  en: {
    ui: {
      close: "Close",
      today: "Today",
      yesterday: "Yesterday",
      language: "Language",
      recordingNamePrefix: "Recording",
      languageSyncError: "Language changed here, but couldn't be saved to your account.",
    },
    sidebarChrome: {
      toggleSidebar: "Toggle Sidebar",
      sidebarSrLabel: "Sidebar",
      mobileSidebarDescription: "Displays the mobile sidebar.",
      arkiiHomeLabel: "arkii home",
      navHome: "Home",
      navProjects: "Projects",
      navAdmin: "Admin Panel",
      contentTitleSettings: "Settings",
      contentTitleHome: "Home",
    },
    sidebarProfile: {
      settings: "Settings",
      signOut: "Sign out",
      signedOut: "Signed out",
      noActivePlan: "No active plan",
      planSuffix: (name) => `${name} plan`,
      balance: "Balance",
      total: "Total",
      remaining: "Remaining",
      unlimited: "Unlimited",
      minutesUnit: "minutes",
    },
  },
  ar: {
    ui: {
      close: "إغلاق",
      today: "اليوم",
      yesterday: "أمس",
      language: "اللغة",
      recordingNamePrefix: "تسجيل",
      languageSyncError: "تم تغيير اللغة هنا، لكن تعذّر حفظها في حسابك.",
    },
    sidebarChrome: {
      toggleSidebar: "تبديل الشريط الجانبي",
      sidebarSrLabel: "الشريط الجانبي",
      mobileSidebarDescription: "يعرض هذا الشريط الجانبي على الجوال.",
      arkiiHomeLabel: "الصفحة الرئيسية لتطبيق آركـي",
      navHome: "الرئيسية",
      navProjects: "المشاريع",
      navAdmin: "لوحة الإدارة",
      contentTitleSettings: "الإعدادات",
      contentTitleHome: "الرئيسية",
    },
    sidebarProfile: {
      settings: "الإعدادات",
      signOut: "تسجيل الخروج",
      signedOut: "تم تسجيل الخروج",
      noActivePlan: "لا يوجد اشتراك فعّال",
      planSuffix: (name) => `خطة ${name}`,
      balance: "الرصيد",
      total: "الإجمالي",
      remaining: "المتبقي",
      unlimited: "غير محدود",
      minutesUnit: "دقيقة",
    },
  },
};
